export const PATIENT_DETAILS_GET = 'PATIENT_DETAILS_GET';
export const PATIENT_DETAILS_GET_SUCCESS = 'PATIENT_DETAILS_GET_SUCCESS';


export const GET_SLOTS_DOC = 'GET_SLOTS_DOC';
export const GET_SLOTS_DOC_SUCCESS = 'GET_SLOTS_DOC_SUCCESS';


export const DOC_DETAILS_GET_CAMPAIGN = 'DOC_DETAILS_GET_CAMPAIGN';
export const DOC_DETAILS_GET_CAMPAIGN_SUCCESS = 'DOC_DETAILS_GET_CAMPAIGN_SUCCESS';


export const DEPARTMENT_DOC_LISTING = 'DEPARTMENT_DOC_LISTING';
export const DEPARTMENT_DOC_LISTING_SUCCESS = 'DEPARTMENT_DOC_LISTING_SUCCESS';


export const FAILED_CAMPAIGN_DOC = 'FAILED_CAMPAIGN_DOC';

export const UPDATE_SCHEDULE_DATA_SLOT = 'UPDATE_SCHEDULE_DATA_SLOT';
export const UPDATE_SCHEDULE_DATA_SLOT_SUCCESS = 'UPDATE_SCHEDULE_DATA_SLOT_SUCCESS';
export const UPDATE_SCHEDULE_DATA_SLOT_ERROR = 'UPDATE_SCHEDULE_DATA_SLOT_ERROR';
